import * as VATValidator from 'vatcode-validator';

function portugueseVatValidation(nif) {
	if (!VATValidator.isValid(`PT${nif}`)) {
		return false;
	} if (
		['1', '2', '3', '5', '6', '8'].indexOf(nif.substr(0, 1)) < 0
		&& ['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'].indexOf(
			nif.substr(0, 2),
		) < -1
	) {
		return false;
	}
	const total =			parseInt(nif[0]) * 9
		+ parseInt(nif[1]) * 8
		+ parseInt(nif[2]) * 7
		+ parseInt(nif[3]) * 6
		+ parseInt(nif[4]) * 5
		+ parseInt(nif[5]) * 4
		+ parseInt(nif[6]) * 3
		+ parseInt(nif[7]) * 2;
	const modulo = total % 11;
	const comparator = modulo < 2 ? 0 : 11 - modulo;
	return parseInt(nif[8]) === comparator;
}

function vatCodeValidator(countryCode, vatNumber) {
	if (countryCode !== 'PT') {
		return VATValidator.isValid(countryCode + vatNumber);
	}
	return portugueseVatValidation(vatNumber);
}

function vatCodeIsEnterprise(countryCode, vatNumber) {
	return countryCode === 'PT' && vatNumber.charAt(0) === '5';
}

export { vatCodeValidator, vatCodeIsEnterprise };
